import api from './../service/apiService'
import { apiUrl } from './../constants/apiUrl'
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../service/logService';
import { PFBAutopay,PAGEACTIVITY } from './../constants/actionType'
import { getCartHeader, getCartData } from './../util/cartUtility'
import { getPieEncryptionValue } from './../util/commonUtil';
import * as checkoutAction from './checkout';
import { InHomeUtils } from './../util/inhomeUtils';
import * as buildProductAction from './buildProduct';
import { vzdlErrorUpdate } from '../service/vzdl';

//POST API Call RequestBody Data 
const getRequestBody = (reqtype, request,isCBA,cbaState,reqbody = "") => {

    let randprofile = String(Math.floor(100000000000 + Math.random() * new Date().valueOf()));
    let profilenamerand = randprofile.length > 12 ? randprofile.substring(0, 12) : randprofile;

    //FRAME AUTOPAY OFFER REQUEST BODY
    if (reqtype === PFBAutopay.onAutopay) {
        reqbody = {
            key: PFBAutopay.onAutopay,
            value: request ? "ACCEPTED" : "DECLINED",
            action: "add"
        }
        return JSON.stringify(reqbody);
    }
    //FRAME CBA REQUEST BODY    
   /* if (reqtype === PFBAutopay.onCBAChange) {
        reqbody = {
            billingsameassvc: false,
            addressline1: `${request.bldghome}${request.prefix}${request.streetName}`,
            addressline2: `${request.unitType}${request.unit}`,
            city: request.city,
            state: request.state,
            zip: request.zipcode
        }
    }*/
    if(request.lqState){
    const {isoneLQFlow, selectedAdr, selectedState, mnh} = request.lqState;
    const payeeAddress = isoneLQFlow ? selectedAdr.dispstr ? selectedAdr.dispstr : selectedAdr.street : selectedAdr.street;
    const payeeCity = isoneLQFlow ? selectedState.muni ? selectedState.muni : selectedState.altCity : selectedState.altCity,
     payeeState = selectedState.state,
     payeeZipCode = selectedState.zip;

    //FRAME VEPS REQUEST BODY FOR CHECKING AND SAVINGS ACCOUNT 
    if (reqtype === PFBAutopay.onCheckingSavingAC) {
        let rand = String(Math.floor(100000000000 + Math.random() * new Date().valueOf()));
        let esignrand = rand.length > 12 ? rand.substring(0, 12) : rand;
        reqbody = [{
            doAutomaticAutopayEnrollment : mnh && mnh.mnhFlow && mnh.checkoutData && mnh.checkoutData.autoPayLast4Digits && request.mnhAutoPayCheckbox && request.mnhAutoPayCheckbox === "yes" ? 'Y' : '',
            client: {
                name: "vzcom",
                id: "vzcom"
            },
            data: {
                serviceAction: "autopay",
                transactionSource: "Desktop",
                orderType: "NEW",
                depositamount: "",
                paymentDetails: [{
                    pmtInd: "B",
                    pmtType: request.action.isCheckingAccount ? "CH" : "SA",
                    bankAcctNum: request.encryptinput.bankAcctNum,
                    bankRoutingNum: request.action.routingNumber,
                    payeeName: `${request.personalInfState.contactInfo.fName}${request.personalInfState.contactInfo.lName}`,
                    payeeAddress,//: request.lqState.selectedAdr.street,
                    payeeCity,//: request.lqState.selectedState.altCity,
                    payeeState,//: request.lqState.selectedState.state,
                    payeeZipCode,//: request.lqState.selectedState.zip,
                    actions: [{
                        actionCode: "ENROLL",
                        eSignConfirmationNum: esignrand // This is the rendom number generation
                    }],
                    bankEncryptionDetails: {
                        keyId: request.encryptinput.key_id,
                        phasebit: request.encryptinput.phase
                    }
                }]
            }
        }]
    }

    //FRAME VEPS REQUEST BODY FOR CREDIT AND DABIT ACCOUNT
    if (reqtype === PFBAutopay.onCreditDebitAC) {

        let getYear = request.action && request.action.expirationDate ? (request.action.expirationDate.Month + request.action.expirationDate.Year.slice(2, 4)):'';
        let rand = String(Math.floor(100000000000 + Math.random() * new Date().valueOf()));
        let esignrand = rand.length > 12 ? rand.substring(0, 12) : rand;
        let cbaStreet='';
        let cbaunit = (isCBA && cbaState.unitType !== "" && cbaState.unit !== "") ? cbaState.unitType + " " + cbaState.unit: "";
        cbaStreet=`${cbaState.streetName} ${cbaunit}`;
        request.encryptinput = request.encryptinput || {};
        reqbody = [{
            doAutomaticAutopayEnrollment : mnh && mnh.mnhFlow && mnh.checkoutData && mnh.checkoutData.autoPayLast4Digits && request.mnhAutoPayCheckbox && request.mnhAutoPayCheckbox === "yes" ? 'Y' : '',
            client: {
                name: "vzcom",
                id: "vzcom"
            },
            data: {
                serviceAction: "autopay",
                transactionSource: "Desktop",
                orderType: "NEW",
                depositamount: "",
                paymentDetails: [{
                    pmtInd: request.action.isCreditAccount ? "C" : "D",
                    pmtType: request.action.cardtype,
                    cardNum: request.encryptinput.cardnumber,
                    securityCode: request.encryptinput.securityCode,
                    profileName: profilenamerand,
                    expirationDt: getYear, //"0920",
                    payeeName: `${request.action.firstName}${request.action.lastName}`,
                    payeeAddress: isCBA? cbaStreet : payeeAddress,//!isCBA?request.lqState.selectedAdr.street:cbaStreet,
                    payeeCity: isCBA? cbaState.city : payeeCity,//!isCBA?request.lqState.selectedState.altCity:cbaState.city,
                    payeeState: isCBA? cbaState.state : payeeState,//!isCBA?request.lqState.selectedState.state:cbaState.state,
                    payeeZipCode: isCBA? cbaState.zipcode : payeeZipCode, //!isCBA? request.lqState.selectedState.zip:cbaState.zipcode,
                    actions: [{
                        actionCode: "ENROLL",
                        eSignConfirmationNum: esignrand // This is the random number generation
                    }],
                    bankEncryptionDetails: {
                        keyId: request.encryptinput.key_id,
                        phasebit: 0
                    }
                }]
            }
        }]
    }

    return JSON.stringify(reqbody);
}
}


//PFB Section Start Here
export const PFBContinueClick = (action, dispatch) => {
    dispatch({
        type: PFBAutopay.onPFBClick,
        value: action
    });
};
export const validatePFB = (action, dispatch) => {
    dispatch({
        type: PFBAutopay.onValidatePFB,
        value: action
    });
}
export const updateEmailID = (action, dispatch) => {
    dispatch({
        type: PFBAutopay.onupdateEmailID,
        value: action
    });
}
//PFB Section End Here
export const updatecvvLength = (action, dispatch) => {
    dispatch({
        type: "AP_CVVMAXLENGTH",
        value: action
    });
};

//AUTOPAY Section Start Here

export const updateFirstnameLastName = (action, dispatch) => {
    dispatch({
        type: PFBAutopay.onupdateFNameLName,
        value: action
    });
}
export const CheckAutoPayOffer = (action, visitId, dispatch, paymenttype,isTargetOrdering,lofChecked) => {
    try{
    dispatch({
        type: 'LOADER_ACTIVE',
        value: { isLoaderActive: true, isLoaderText: "Lets wait for a moment, we are processing your request.", isLoaderImg: "loader" }
    });
    // Apply the Autopay Discount Here
   // let applyAutopayOffer = apiUrl().updateintentcart + '/' + visitId;
   let applyAutopayOffer = apiUrl().updateintentcartAcc + '/' + visitId;
    let requestBody = getRequestBody(PFBAutopay.onAutopay, action)
    api(applyAutopayOffer, 'POST', requestBody).then(response => {
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && response.meta.code === 200) {
            dispatch({
                type: "UPDATE_CART",
                 value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent,visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent,visitId),
                        cartOrderDetail:response.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                    }
            }); 
            dispatch({
                type: PFBAutopay.onCheckAutoPayOffer,
                value: action
            });
            //Dispatch for Credit Card Payment Selection
            dispatch({
                type: PFBAutopay.onCreditPayment,
                value: paymenttype
            });
            if (isTargetOrdering) {
                if (lofChecked) {
                    dispatch({
                        type: PFBAutopay.autopayChecked,
                        value: false
                    });
                    dispatch({
                        type: "LOF_CHECKED",
                        value: true
                    });
                }
                else {
                    dispatch({
                        type: PFBAutopay.autopayChecked,
                        value: true
                    });
                    dispatch({
                        type: "LOF_CHECKED",
                        value: false
                    });
                }
            }           

            dispatch({type: 'LOADER_ACTIVE',value: false});
            buildProductAction.fetchPostSoc(dispatch,visitId,"",true);
        }
    })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            logKafka("ERROR", "Checkout", error.message, getErrorLogUrl, "applogs", visitId);
            dispatch({
                type: 'LOADER_ACTIVE',
                value: { isLoaderActive: false }
            });
        }
        );
    }
    catch(ex){
        catchJSException('pfbAutopay', visitId, 'action-CheckAutoPayOffer', ex);
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: false }
        });
    }
};
export const PaymentModeChanges = (action, dispatch) => {
    dispatch({
        type: PFBAutopay.onPaymentModeChange,
        value: action
    });
};
export const clearCardDetails = (action, dispatch) => {
    dispatch({
        type: PFBAutopay.onClearCard,
        value: action
    });
};
export const showMnhAutoPay = (action,dispatch) => {
    dispatch({
        type: "SHOWMNHAUTOPAY",
        value: action
    });
}
export const mnhAutoPayCheckbox = (action,dispatch) => {
    dispatch({
        type: "MNHAUTOPAYCHECKBOX",
        value: action
    });
}
export const validateAutoPay = (action, dispatch) => {
    dispatch({
        type: PFBAutopay.onValidateAutoPay,
        value: action
    });
}
//Validate Autopay Card Details 

export const validateAutoPayInfo = async (action, dispatch, cardType, lqState, personalInfState, visitId, mnhAutoPayCheckbox, isCBA, cbaState, isReskinAPPfbCardFlow=false ) => {
    try{
    dispatch({
        type: 'LOADER_ACTIVE',
        value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
    });
    let requestBody = "";
    let isVerizonVisaCC= false;
    let encryptinput = getPieEncryptionValue(action, "AUTOPAY",visitId);
    let appendadValues = {
        action: action,
        encryptinput: encryptinput,
        lqState: lqState,
        personalInfState: personalInfState,
        mnhAutoPayCheckbox: mnhAutoPayCheckbox
    };
    let url = apiUrl().vepsUrl;
    if (cardType === PFBAutopay.onCheckingSavingAC) {
        requestBody = getRequestBody(PFBAutopay.onCheckingSavingAC, appendadValues)
    }
    else if (cardType === PFBAutopay.onCreditDebitAC) {
        requestBody = getRequestBody(PFBAutopay.onCreditDebitAC, appendadValues,isCBA,cbaState)
    }
    return api(url, 'POST', requestBody).then(response => {        
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && response.meta.code === 200.01) {
            //response.data.pmtType = 'VZ'
            if (InHomeUtils.isNotNull(response.data) && response.data.status?.toLowerCase() === PFBAutopay.onAPIResponseCheck.onSuccess) { // Pass Scenario  - we cannot check through based on code bcz its always returning : meta.code === "200.01"
            if(InHomeUtils.isNotNull(response.data.pmtType) && response.data.pmtType === 'VZ'){
                isVerizonVisaCC= true;
                updateIsVerizonVisaCC(true, dispatch)
                CheckAutoPayOffer(true, visitId, dispatch, false)
            }   
            dispatch({
                    type: "CO_VEPSCALL",
                    value: response.data
                });
                dispatch({type: 'LOADER_ACTIVE',value: false});
                if(isReskinAPPfbCardFlow)
                    return {response: true, isVerizonVisaCC}
                return true;
            }
            else if (InHomeUtils.isNotNull(response.data) && response.data.status?.toLowerCase()?.includes(PFBAutopay.onAPIResponseCheck.onFailure)) { //Failed Scenario
                dispatch({
                    type: "CO_VEPSCALL",
                    value: response.data
                });
                vzdlErrorUpdate( response.meta.code,`${response.data.displayMessage} ${response.data.message}`,"event11");
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'VEPS REJECTED',PAGEACTIVITY.UA));
            }
        }
        else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotEmpty(response.meta) && response.meta.code === 500.01) {
            dispatch({
                type: "CO_VEPSCALL",
                value: response.meta
            });
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'VEPS API Error',PAGEACTIVITY.UA));
        }
        else{
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'VEPS API Error',PAGEACTIVITY.UA));
        }
        dispatch({type: 'LOADER_ACTIVE',value: false});
        if(isReskinAPPfbCardFlow)
            return {response: false, isVerizonVisaCC}
        return false;
    }
    )

        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:validateAutoPayInfo,errorMessage:${error.message}`;
            logKafka("ERROR", "AUTOPAY", errorMsg, getErrorLogUrl, "applogs", "");
            dispatch({type: 'LOADER_ACTIVE',value: false});
        });
    }
    catch(ex){
        catchJSException('pfbAutopay', visitId, 'action-validateAutoPayInfo', ex);
        dispatch({type: 'LOADER_ACTIVE',value: false});
    }

};

export const validateAutoPayInfoNew = async (action, dispatch, cardType, lqState, personalInfState, visitId, mnhAutoPayCheckbox, isCBA, cbaState, isReskinAPPfbCardFlow=false, paymentType="" ) => {
    try{
    dispatch({
        type: 'LOADER_ACTIVE',
        value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
    });
    let requestBody = "";
    let isVerizonVisaCC= false;
    let encryptinput = getPieEncryptionValue(action, "AUTOPAY",visitId);
    let appendadValues = {
        action: action,
        encryptinput: encryptinput,
        lqState: lqState,
        personalInfState: personalInfState,
        mnhAutoPayCheckbox: mnhAutoPayCheckbox
    };
    let url = apiUrl().vepsUrl;
    if (cardType === PFBAutopay.onCheckingSavingAC) {
        requestBody = getRequestBody(PFBAutopay.onCheckingSavingAC, appendadValues)
    }
    else if (cardType === PFBAutopay.onCreditDebitAC) {
        requestBody = getRequestBody(PFBAutopay.onCreditDebitAC, appendadValues,isCBA,cbaState)
    }
    return api(url, 'POST', requestBody).then(response => {  
        let apoDiscountEligiblePmtMethod = response?.data?.apoDiscountEligiblePmtMethod?.toUpperCase() ==="Y" 
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response?.meta) && response?.meta?.code === 200.01) {
            //response.data.pmtType = 'VZ'
            if (InHomeUtils.isNotNull(response?.data) && response?.data?.status?.toLowerCase() === PFBAutopay.onAPIResponseCheck.onSuccess) { // Pass Scenario  - we cannot check through based on code bcz its always returning : meta.code === "200.01"
            if(InHomeUtils.isNotNull(response?.data?.pmtType) && response?.data?.pmtType === 'VZ' && apoDiscountEligiblePmtMethod){
                isVerizonVisaCC= true;
                updateIsVerizonVisaCC(true, dispatch)
                updateAutopayEligible(true, dispatch)
                CheckAutoPayOffer(true, visitId, dispatch, false)
            }  
            else if(InHomeUtils.isNotNull(response?.data?.pmtType) && response?.data?.pmtType === 'VZ' && !apoDiscountEligiblePmtMethod){
                isVerizonVisaCC= true;
                updateIsVerizonVisaCC(true, dispatch)
                updateAutopayEligible(false, dispatch)
                // CheckAutoPayOffer(false, visitId, dispatch, false)
            } 
            else if(InHomeUtils.isNotNull(response?.data?.pmtType) && (response?.data?.pmtType !=='VZ' && apoDiscountEligiblePmtMethod)){
                updateAutopayEligible(true, dispatch)
                CheckAutoPayOffer(true, visitId, dispatch,false)
            }else if(InHomeUtils.isNotNull(response?.data?.pmtType) && (response?.data?.pmtType !=='VZ' && !apoDiscountEligiblePmtMethod)
            )  {
                updateAutopayEligible(false, dispatch)
                // CheckAutoPayOffer(false, visitId, dispatch, paymentType === "CREDIT")
            }         

            dispatch({
                    type: "CO_VEPSCALL",
                    value: response.data
                });
                dispatch({type: 'LOADER_ACTIVE',value: false});
                if(isReskinAPPfbCardFlow)
                    return {response: true, isVerizonVisaCC,apoDiscountEligiblePmtMethod}
                return true;
            }
            else if (InHomeUtils.isNotNull(response.data) && response?.data?.status?.toLowerCase()?.includes?.(PFBAutopay.onAPIResponseCheck.onFailure)) { //Failed Scenario
                dispatch({
                    type: "CO_VEPSCALL",
                    value: response.data
                });
                vzdlErrorUpdate( response.meta.code,`${response.data.displayMessage} ${response.data.message}`,"event11");
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'VEPS REJECTED',PAGEACTIVITY.UA));
            }
        }
        else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotEmpty(response.meta) && response.meta.code === 500.01) {
            dispatch({
                type: "CO_VEPSCALL",
                value: response.meta
            });
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'VEPS API Error',PAGEACTIVITY.UA));
        }
        else{
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'VEPS API Error',PAGEACTIVITY.UA));
        }
        dispatch({type: 'LOADER_ACTIVE',value: false});
        if(isReskinAPPfbCardFlow)
            return {response: false, isVerizonVisaCC,apoDiscountEligiblePmtMethod}
        return false;
    }
    )

        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:validateAutoPayInfo,errorMessage:${error.message}`;
            logKafka("ERROR", "AUTOPAY", errorMsg, getErrorLogUrl, "applogs", "");
            dispatch({type: 'LOADER_ACTIVE',value: false});
        });
    }
    catch(ex){
        catchJSException('pfbAutopay', visitId, 'action-validateAutoPayInfo', ex);
        dispatch({type: 'LOADER_ACTIVE',value: false});
    }

};

export const changeDescriptionInfo = (action, dispatch) => {
    dispatch({
        type: 'RESET_DESCRIPTION',
        value: action
    });
};
//Change AutoPay Review 
export const changeAutoPayInfo = (action, dispatch) => {
    dispatch({
        type: PFBAutopay.onAutoPayReviewChange,
        value: action
    });
};
export const completePFBAutopaySection = (action, dispatch) => {
    dispatch({
        type: PFBAutopay.onPFBAutoPayStatus,
        value: action
    });
};

//Validate CBA
export const validateCBA = (action, dispatch) => {
    dispatch({
        type: PFBAutopay.onValidateCBA,
        value: action
    });
}
export const streetErr = (status, dispatch) => {
    dispatch({ type: PFBAutopay.streetErr, value: status })
};
export const cityErr = (status, dispatch) => {
    dispatch({ type: PFBAutopay.cityErr, value: status })
};
export const stateErr = (status, dispatch) => {
    dispatch({ type: PFBAutopay.stateErr, value: status })
};
export const zipErr = (status, dispatch) => {
    dispatch({ type: PFBAutopay.zipErr, value: status })
};
export const pfbChecked = (status, dispatch) => {
    dispatch({ type: PFBAutopay.PFBChecked, value: status })
};
export const updateAutoPayType = (type, dispatch) => {
    dispatch({ type: PFBAutopay.autoPayType, value: type })
};
export const updateBankAccountType = (type, dispatch) => {
    dispatch({ type: PFBAutopay.bankAccountType, value: type })
};
export const updateIsAutoPayFormSaved = (status, dispatch) => {
    dispatch({ type: PFBAutopay.isAutopayFormSaved, value: status })
};
export const updateIsShowAlertPaymentBanner = (status, dispatch) => {
    dispatch({ type: PFBAutopay.isShowPaymentAlertBanner, value: status })
};
export const updateFocusBanner = (status, dispatch) => {
    dispatch({ type: PFBAutopay.focusAlertBanner, value: status })
};
export const updateEnableAutoPayPFBReskin = (status, dispatch) => {
    dispatch({ type: PFBAutopay.enablePFBautoPayReskin, value: status })
};
export const updateIsVerizonVisaCC = (status, dispatch) => {
    dispatch({ type: PFBAutopay.isVerizonVisaCC, value: status })
};
export const updateAutopayEligible = (status, dispatch) =>{
    dispatch({ type: PFBAutopay.isAutopayEligible, value: status })
}
export const autopayChecked = (status, dispatch) => {
    dispatch({ type: PFBAutopay.autopayChecked, value: status });
    //Setting Cart Dirty as True when autopay decline- for Validate Cart on submit order
    if(!status){
        dispatch({ type: 'SET_CART_DIRTY', value: true })
    }
};
export const pfbUnCheckedContinue = (status, dispatch) => {
    dispatch({ type: PFBAutopay.pfbUnCheckedContinue, value: status })
};

export const CBASaveContinue = (action, dispatch) => {
    dispatch({
        type: PFBAutopay.onCBASave,
        value: action
    });
}
export const pfbTosAgree = (action,dispatch) => {
    dispatch({ type: PFBAutopay.pfbTosAgree, value: action })
}

export const updatedigitalBillEnrollment = (visitId, paperFreeEnrollment = true) => {
    try {
        let url = apiUrl().updatedigitalBillEnrollment;
        let request = JSON.stringify({ "digitalBillEnrollment": paperFreeEnrollment ? "Y" : "N" });
        api(url, 'POST', request).then(response => {
        })
            .catch(ex => {
                catchJSException('PFBAutoPay', visitId, 'updatedigitalBillEnrollment', ex);
            });
    }
    catch (ex) {
        catchJSException('PFBAutoPay', visitId, 'updatedigitalBillEnrollment', ex);
    }
}

export const autopayTosAgree = ( action,dispatch) => {
    dispatch({ type: PFBAutopay.autopayTosAgree, value: action })
}

export const autopayPFBTosAgree = (action, dispatch) => {
    dispatch({ type: PFBAutopay.autopayPFBTosAgree, value: action })
}
                   
export const lofOptionClick = (dispatch, optionType) => {
       dispatch({ type: "LOF_OPTIONCLICK", value: optionType })
}

export const lofAutoPayContinue = (visitId, dispatch, mtn, eMailId, lofOptionValue, pfbChecked, autopayChecked, isAutoPay, isInternetAdded, isTvAdded, isVoiceAdded, isPFBorDB, lofChecked, isFCP) => {
    try{
    let url = apiUrl().sendLofNotification;
    dispatch({
        type: 'LOADER_ACTIVE',
        value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
    });
    api(url, 'POST', getLofAutoPayRequest(mtn, eMailId, lofOptionValue, visitId, pfbChecked, autopayChecked, isAutoPay, isInternetAdded, isTvAdded, isVoiceAdded, isPFBorDB, dispatch, isFCP)).then(response => {
        if (lofChecked) {
            checkoutAction.updateAutoPayAccordion('change', dispatch)
            dispatch({ type: "LOF_TOSENABLE", value: true })
        }
        else {
            dispatch({ type: "LOF_AUTOPAYCLICKED", value: true })
        }
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:lofAutoPayContinue,errorMessage:${error.message}`;
            logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs", visitId);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            dispatch({ type: "LOF_AUTOPAYCLICKED", value: false })
        });
    }
    catch(ex){
        catchJSException('pfbAutopay', visitId, 'action-lofAutoPayContinue', ex);
    }
};
   
const getLofAutoPayRequest = (mtn, eMailId, lofOptionValue, visitId, pfbChecked, autopayChecked, isAutoPay, isInternetAdded, isTvAdded, isVoiceAdded,isPFBorDB,dispatch, isFCP) => {
    let srvcs = "";
    let isStandAlone=false;
    let tosType="";
    let tosTypeSrvcs=""
    if(isInternetAdded&& !isTvAdded && !isVoiceAdded){
        isStandAlone=true;
    }
    else if(!isInternetAdded&& isTvAdded && !isVoiceAdded){
        isStandAlone=true;
    }
    if (isInternetAdded) {
        srvcs += "INTERNET";
    }
    if (isTvAdded) {
        srvcs +=",TV";
    }
    if (isVoiceAdded) {
        srvcs += ",PHONE";
    }
    if(isStandAlone){
        tosType="STANDALONE"
    }
    else if (!isFCP){
        tosType="BUNDLE"
    }
    tosTypeSrvcs=tosType+","+srvcs;
    if(isPFBorDB==="DB"){
        tosTypeSrvcs+=",DIGITAL";
    }
    let request = {
        data: {
            email: (lofOptionValue === "EMAIL" ? eMailId : ""),
            deliveryType: (lofOptionValue === "EMAIL" ? "email" : "mtn"),
            mtn: (lofOptionValue === "MTN" ? mtn : ""),
            tosType: tosTypeSrvcs,
            pfbIntent: pfbChecked ? "Y" : "N",
            autopayIntent: autopayChecked ? "Y" : "N",
            autopayPromoFlag: isAutoPay ? "Y" : "N",
            productDetails: srvcs,
            orderStatus: "PREVIEW"
        }
    }
    dispatch({ type: "LOF_AUTOPAYREQUEST", value: request})
    return JSON.stringify(request);    
}
   
export const lofCheckStatus = (visitId, dispatch,noOfAttempts,autopayCheck) => {
    try{
       let url = apiUrl().lofStatus;
       api(url, 'GET', '').then(response => {
           if (noOfAttempts < 2) {
               if (InHomeUtils.isNotNull(response) && response.status === "SUCCESS") {
                   if(!autopayCheck && response.autoPayStatus){
                      CheckAutoPayOffer(true, visitId, dispatch, true,false,false)
                      autopayChecked(true,dispatch);
                   }
                   checkoutAction.updateAutoPayAccordion('completed', dispatch)
                   dispatch({ type: "LOF_AUTOPAYCLICKED", value: false })
                   dispatch({ type: "LOF_TOSENABLE", value: false })
                   dispatch({ type: "LOF_SUCCESS", value: true })
                   dispatch({ type: "LOF_RESUBMIT_STATUS", value: false })                   
               }
               else {
                   dispatch({ type: "LOF_AUTOPAYCLICKED", value: false })
                   dispatch({ type: "LOF_RESUBMIT_STATUS", value: true })
               }
           }
           else {
               checkoutAction.updateAutoPayAccordion('change', dispatch)
               CheckAutoPayOffer(false, visitId, dispatch, false,false,false)
               autopayChecked(false,dispatch);
               dispatch({ type: "LOF_TOSENABLE", value: true })
               dispatch({ type: "LOF_AUTOPAYCLICKED", value: false })
               dispatch({ type: "LOF_RESUBMIT_STATUS", value: false })
           }
       })
           .catch(error => {
               let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
               let errorMsg = `MethodName:lofCheckStatus,errorMessage:${error.message}`;
               logKafka("ERROR", "SAVECART", errorMsg, getErrorLogUrl, "applogs", visitId);
               dispatch({ type: "LOF_TOSENABLE", value: true })
               CheckAutoPayOffer(false, visitId, dispatch, false,false,false)
               autopayChecked(false,dispatch);
           });
        }
        catch(ex){
            catchJSException('pfbAutopay', visitId, 'action-lofCheckStatus', ex);
        }
}

export const PFBProfileVerified = (action, dispatch) => {
    dispatch({
        type: PFBAutopay.onPFBProfileVerified,
        value: action
    });
};

